import React from 'react';

export default React.createContext();



// WEBPACK FOOTER //
// ./src/components/contexts/AuthenticationContext.js